import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const KidCtx = createContext(null);

export function KidProvider({ children }) {
  const { user } = useAuth();
  const [kids, setKids] = useState([]);
  const [activeId, setActiveId] = useState(() => localStorage.getItem("cdf_active_kid") || "");
  const [taxonomy, setTaxonomy] = useState({ categories: [], themes: [], age_groups: [], ranks: [] });

  const loadKids = useCallback(async () => {
    if (!user) return;
    const { data } = await api.get("/children");
    setKids(data.children || []);
    if (!activeId && data.children?.length) {
      setActiveId(data.children[0].id);
      localStorage.setItem("cdf_active_kid", data.children[0].id);
    }
  }, [user, activeId]);

  const loadTaxonomy = useCallback(async () => {
    const { data } = await api.get("/taxonomy");
    setTaxonomy(data);
  }, []);

  useEffect(() => { if (user) { loadKids(); loadTaxonomy(); } }, [user, loadKids, loadTaxonomy]);

  const setActive = (id) => {
    setActiveId(id);
    localStorage.setItem("cdf_active_kid", id);
  };

  const active = kids.find((k) => k.id === activeId) || kids[0] || null;

  return (
    <KidCtx.Provider value={{ kids, active, activeId: active?.id, setActive, reloadKids: loadKids, taxonomy }}>
      {children}
    </KidCtx.Provider>
  );
}

export const useKid = () => useContext(KidCtx);
